module.exports = __webpack_public_path__ + "static/forecast/forecast-sunset-edae9276c7fd3450f026d123511e34d6.svg";